<template>
	<div>
		<ValidationObserver
			ref="observer"
			tag="form"
			class="form"
		>
			<div class="section-title is-small">
				{{ title }}
			</div>
			<div class="section-description is-medium">
				Current password
			</div>
			<AppInput
				v-model="form.OldPassword"
				size="full"
				color="underline"
				placeholder="Enter your current password"
				type="password"
				:rules="{ required: true }"
				mode="aggressive-touch"
			/>
			<div class="section-description is-medium">
				New password
			</div>
			<AppInput
				v-model="form.NewPassword"
				size="full"
				color="underline"
				placeholder="Enter your desired password"
				type="password"
				:rules="{ required: true }"
				vid="confirm"
				mode="aggressive-touch"
			/>
			<div class="section-description is-medium">
				Confirm new password
			</div>
			<AppInput
				v-model="form.NewPasswordConfirmation"
				size="full"
				color="underline"
				placeholder="Confirm your desired password"
				type="password"
				:rules="{ required: true, confirmed: 'confirm' }"
				mode="aggressive-touch"
			/>
			<div class="buttons">
				<router-link :to="{name: 'Dashboard'}">
					<AppButton
						size="medium"
						color="outline-light"
						gap="right"
					>
						Cancel
					</AppButton>
				</router-link>
				<AppButton
					v-if="!changesSaved"
					size="medium"
					color="primary"
					class="button"
					@click="saveChanges"
				>
					Save changes
				</AppButton>
				<AppButton
					v-if="changesSaved"
					size="medium"
					color="grey"
					item="icon"
				>
					<img
						src="@/assets/check.png"
						class="small-img"
						alt="check"
					>
					Save changes
				</AppButton>
			</div>
		</validationobserver>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';

export default {
	name: 'SettingsPassword',

	components: {
		ValidationObserver,
	},

	data() {
		return {
			title: 'Change password',
			changesSaved: false,
			form: {
				OldPassword: '',
				NewPassword: '',
				NewPasswordConfirmation: '',
			},
		};
	},

	watch: {
		form: {
			async handler() {
				this.formIsValid = await this.$refs.observer.validate({ silent: true });
				this.changesSaved = false;
			},
			deep: true,
		},
	},

	methods: {
		...mapActions('auth', [
			'changePassword',
		]),
		async saveChanges() {
			try {
				await this.changePassword({ ...this.form });
				this.$notify({
					type: 'info',
					title: '',
					text: 'you saved your new password',
				});
				this.changesSaved = true;
			} catch (error) {
				this.$notify({
					type: 'error',
					title: '',
					text: 'oops. Something went wrong.',
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.section-description {
	color: $color-accent-200;
	margin-top: $gap-5;
	margin-bottom: $gap-05;
}

.buttons {
	display: flex;
	justify-content: flex-end;
	margin-top: $gap-5;

	.button {
		margin-right: $gap-2;

		&:last-child {
			margin-right: 0;
		}
	}
}

.section-items {
	display: flex;
	align-items: center;
	margin-top: $gap-3;

	.item-img {
		width: 80px;
		height: 80px;
		border: 1px solid $color-accent-400;
		border-radius: 50%;
		overflow: hidden;
		margin-right: $gap-2;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>
